var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "user-login-privacy" },
    [
      _vm.checked
        ? [
            _c("span", [_vm._v("登录视为您已同意")]),
            _c(
              "span",
              { staticClass: "hl", on: { click: _vm.toPrivacyPage } },
              [_vm._v(" Metacare用户协议与隐私政策")]
            ),
          ]
        : [
            _c(
              "a-checkbox",
              {
                on: {
                  change: (e) =>
                    _vm.$emit("on-change", e?.target?.checked || false),
                },
              },
              [_c("span", [_vm._v("我已阅读并同意")])]
            ),
            _c(
              "span",
              {
                staticStyle: { "margin-left": "-10px" },
                on: { click: _vm.toPrivacyPage },
              },
              [
                _c("span", { staticClass: "hl" }, [
                  _vm._v(" Metacare用户协议与隐私政策"),
                ]),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }